
export default {
  productData: {
    serialNumber: 'DA-MMEU-001',
    name: 'Massivholzdecke mit Estrich und Unterdecke l Aufbau 1',
    construction: {
      composition: [
        {
          type: 'screed',
          title: { de: 'Estrich' },
          output: '≥ 60',
          value: 'w-60'
        },
        {
          type: 'insulation',
          title: { de: 'Holzfaserdämmplatte WF<br>(<i>s‘</i> ≤ 50 MN/m<sup>3</sup>; Anwendungsgebiet DES-sh)' },
          output: '≥ 20',
          value: 'w-20'
        },
        {
          type: 'fill',
          title: { de: 'Mit StoPrefa Coll SB gebundene Schüttung (<i>m‘</i> ≥ 190 kg/m<sup>2</sup>), Rieselschutz' },
          output: '≥ 120',
          value: 'scsb-120'
        },
        {
          type: 'supportingStructure',
          title: { de: 'Massivholzdecke (Steico GLVL)' },
          output: 120,
          value: 'mh-120'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'U-Abhänger, schallentkoppelt mit Lattung 60/27' },
          output: 80,
          value: 'uas-80'
        },
        {
          type: 'suspendedCeilingA',
          title: { de: 'Gipsplatte GKB' },
          output: '12,5',
          value: 'g-12.5'
        }
      ],
      sum: {
        output: '412,5', value: 412.5
      }
    },
    technicalValues: {
      impactSoundLevel: { // L,nw
        output: '55 (1; 2)',
        value: 55
      },
      soundReductionIndex: { // Rw
        output: '65 (-4; -12)',
        value: 65
      },
      heatTransferCoefficient: { // U-Wert
        output: '0,50',
        value: 0.50
      },
      fireResistance: {
        output: 'F 30-B',
        value: 'F-30-B'
      },
      massPerUnitArea: {
        output: '440 [kg/m²]'
      }
    }
  },
  image: 'da-mmeu-001.png',
  pdf: 'Massivholzdecke-mit-Estrich-und-Unterdecke-Aufbau-1-DA-MMEU-001-Rev01.pdf'
}
